import * as yup from "yup";
import { Form } from "./Form";
import { Button } from "../button/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const BaseForm = ({
  validationSchema = yup.object({}),
  defaultValues,
  onSubmitHandler,
  children,
  isCreationForm = true,
}) => {
  const form = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmitHandler)}
        className="w-full px-5"
      >
        <div className="flex flex-col justify-center gap-y-4">{children}</div>
        <div className="flex flex-row mt-8 justify-end">
          <Button type="submit">{isCreationForm ? "Create" : "Accept"}</Button>
        </div>
      </form>
    </Form>
  );
};

export default BaseForm;
